
import styled from "styled-components";
import { Col, Divider, Row} from "antd";
import {GhostButtonComponent} from "../../../../../../../CommonComponents/commonStyles";
import theme from '../../../../../../../styles/theme';


export const GrantsPaymentContent = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  padding-right: 50px;
  padding-left: 50px;
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom:  ${props =>(props.marginBottom === undefined)? "10px": props.marginBottom};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props)? props.mobmb : '10px'}
  }
`;

export const AddressContainer = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    margin-left: 150px;
    line-height: ${props => props.theme.lineHeight.secondary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    color: ${props => props.theme.fontColors.thead};
    margin-bottom: 200px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    margin-left: 50px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props)? props.mobmb : '10px'}
    }
`;

export const AdvisorContainer = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    margin-left: 150px;
    margin-bottom:20px;
    line-height: ${props => props.theme.lineHeight.secondary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    color: ${props => props.theme.fontColors.thead};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    margin-left: 30px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props)? props.mobmb : '10px'}
    }
    max-width: 200px;
    float: left;
`;

export const ImageContainer = styled.div`
  padding-top: 6px;
`

export const Img = styled.img`
  width: 143px;
  height: 60px;
  @media only screen and (max-width: 576px) {
    width: 120px;
    height: 48px;
  }
`;

export const DataContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  padding-left: 150px;
  margin-bottom: ${props =>props.marginBottom ? props.marginBottom : "10px"};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    padding-left: 10px;
    margin-bottom: ${props => (props)? props.mobmb : '10px'};
  }
`;

export const DataHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  padding-right: 50px;
  padding-left: 50px;
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom:  ${props =>(props.marginBottom === undefined)? "10px": props.marginBottom};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props)? props.mobmb : '10px'}
  }
`;

export const FirstColumn = styled(Col)`
padding-left: 50px;
  @media only screen and (max-width: 990px) {
    padding-left: 10px;
  }
`;


export const SecondColumn = styled(Col)`
  padding-left: 50px;
  @media only screen and (max-width: 990px) {
    padding-left: 10px;
  }
`;


export const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const CancelButton = styled(GhostButtonComponent)`
  width: 9.375rem;
  @media (min-width: 320px) and (max-width: 990px) {
    width: 9.375rem;
  }
`;


export const HorizontalDivider = styled(Divider)`
  border-bottom: solid 1px #bfbfbf;
  &.noMargin{
    margin: 0px;
  }
  &.blurify {
    margin-bottom: 3rem;
    opacity: 0.4;
  }
  @media only screen and (max-width: 990px) {
    margin: 0rem;
    margin-bottom: 1rem;
    }
`;


export const InfoContent = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom:  ${props =>(props.marginBottom === undefined)? "10px": props.marginBottom};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props)? props.mobmb : '10px'}
  }
`;


export const GrantContent = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom:  ${props =>props.marginBottom ? props.marginBottom : "10px"};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props)? props.mobmb : '10px'}
  
  }
`;
export const GrantContentItalic = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    font-style: italic;
    line-height: ${props => props.theme.lineHeight.secondary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    color: ${props => props.theme.fontColors.thead};
    margin-bottom:  ${props => props.marginBottom ? props.marginBottom : "10px"};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
        line-height: ${props => props.theme.lineHeight.tableFont};
        letter-spacing: ${props => props.theme.letterSpacing.normal};
        margin-bottom: ${props => (props)? props.mobmb : '10px'}
    }
`;

export const DataContainerLetter = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  padding-left: 150px;
  margin-bottom:  10px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    padding-left: 10px;
    margin-bottom: ${props => (props)? props.mobmb : '10px'}
  }
`;
export const GrantsPaymentContentPurposeBased = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  padding-right: 50px;
  padding-left: 150px;
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom:  ${props => props.marginBottom ? props.marginBottom : "10px"};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props)? props.mobmb : '10px'}
  }
`;
export const GrantsPaymentContentCC = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    padding-right: 50px;
    padding-left: 50px;
    line-height: ${props => props.theme.lineHeight.secondary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    color: ${props => props.theme.fontColors.thead};
    margin-bottom: 0px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props)? props.mobmb : '10px'}
    }
`;

{/* grant agreement document*/}

export const GrantPaymentLetterAddressWrapper = styled.div`
  margin-left: 25%;
  color: ${props => props.theme.fontColors.thead};
  font-size: ${props => props.theme.fontSize.primary};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
`;
export const AgreedAgreementWrapper = styled.div`
  margin-left: 50px;
  margin-top: 50px;
  margin-bottom: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 0px;
  }
`;
export const SignatureFloatRightDiv = styled.div`
  float: right;
  max-width: 287px;
  line-height: 2.5;
  margin-right: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    float: left;
  }
  
`;
export const SignatureFloatLeftDiv = styled.div`
  float: left;
  margin-right: 50px;
  @media only screen and (min-width: 414px) {
    width: 288px;
  }
`;
export const SignatureFloatRightFirstDiv = styled.div`
  float: right;
  max-width: 287px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    float: left;
  }
  @media only screen and (min-width: 391px) {
    margin-right: 176px;
  }
  
`;
export const GrantPaymentSectionTitle = styled.p`
  margin-left: 50px;
  color: ${props => props.theme.colors.secondaryColor};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-left: 0px;
  }
`;
export const GrantPaymentUnorderList = styled.span`
  color: ${props => props.theme.colors.secondaryColor};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
`;
export const GrantPaymentUnorderListContent = styled.span`
  color: ${props => props.theme.fontColors.thead};
`;
export const GarntPaymentUnorderListWrapper = styled.div`
  margin-left: 50px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  padding-right: 20px;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-left: 0px;
  }
`;
export const GrantPaymentSignatureWrapper = styled(Row)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  margin-left: 50px;
  color: ${props => props.theme.fontColors.thead};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 0px;
    padding-left: 20px;
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
`;
export const GrantPaymentSignatureDiv = styled.div`
  overflow: hidden;
  margin-top: 15px;
`;
export const HorizontalDividerWrapper = styled.div`
    margin-top: 200px;
`;
export const GrantAgreementTable = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  margin-top: 15px;
  margin-bottom: 15px;
`;
export const GrantTableHeader = styled(Row)`
  border: 1px solid ${props => props.theme.colors.black};
  border-bottom: none;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.secondaryColor};
  @media only screen and (min-width: 768px) {
    margin-left: 25%;
    margin-right: 25%;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 0px;
    margin-right: 0px;
  }
`;
export const tableFirstColumn = {
  borderRight: `1px solid ${theme.colors.black}`,
  paddingLeft: '10px'
}
export const tablePaddingBorder = {
  borderRight: `1px solid ${theme.colors.black}`,
  paddingLeft: '10px',
  borderBottom: `1px solid ${theme.colors.black}`
}
export const GrantPaymentTable = styled(Row)`
  margin-left:25%;
  margin-right:25%;
  border: 1px solid ${props => props.theme.colors.black};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin-left: 0px;
      margin-right: 0px;
  }
`;
export const FlexDiv = styled.div`
  display: flex;
`;
export const grantAmount= {
  paddingLeft: '10px',
  borderBottom: `1px solid ${theme.colors.black}`
}
export const Finalitem = {
  paddingLeft: '10px',
  borderBottom: 'none'
}
export const PaddingLeft = {
  paddingLeft: '10px'
}
export const FloatLeft = {
  float: 'left'
}
export const ImageFloatRightDiv = styled.div`
  float: right;
  max-width: 287px;
  line-height: 2.5;
  margin-right: 40px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    float: right;
    margin-right: 0px;
  }
  
`;
export const GrantPaymentSSRTitle = styled.p`
  margin-top: 42px;
  margin-left: 50px;
  margin-bottom:0px;
  color: ${props => props.theme.colors.secondaryColor};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 59px;
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-left: 0px;
  }
`;

export const GrantPaymentOrgName = styled.p`
  margin-left: 50px;
  margin-bottom:25px;
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    margin-left: 0px;
  }
`;
export const SignatureRow = styled(Row)`
  margin-bottom : 15px;
  @media only screen and (max-width: 992px) {
    margin-bottom : 0px;
  }
`;


export const FundWrapper = styled.span`
  word-break: break-all;
`;